module.exports = __webpack_public_path__ + "img/3d-mobile_cn.8113f4f.jpg";